import { useState } from "react";
import { usePromise } from "rooks";

import { requestCameraAccess } from "utils/camera";

type CameraReturn = {
  hasAccess: boolean;
  requestAccess: () => Promise<void>;
  checkAccess: () => Promise<boolean>;
};

export function useCamera(): CameraReturn {
  const [hasAccess, setHasAccess] = useState(false);

  const checkAccess = async () => {
    const permissionStatus = await navigator.permissions.query({
      name: "camera" as PermissionName,
    });

    const isGranted = permissionStatus.state === "granted";
    setHasAccess(isGranted);

    return isGranted;
  };

  /**
   * Checks initially if the camera is enabled
   */
  usePromise(checkAccess);

  const requestAccess = async () => {
    const mediaStream = await requestCameraAccess();
    setHasAccess(mediaStream !== null);
  };

  return {
    hasAccess,
    requestAccess,
    checkAccess,
  };
}
